var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"w-full h-full",attrs:{"src":"/img/IconDashboardTemplate.png","alt":"template"}})
}
var staticRenderFns = []

export { render, staticRenderFns }